<template>
  <div>    
    <a-alert :message="this.$t('ujian.ujian-dashboard.question')" type="info">
      <p slot="description">
        <span v-html="itemsoal.question"></span>        
      </p>
    </a-alert>
    <br />

    <h4>{{ $t("ujian.ujian-dashboard.answer") }}</h4>
    
    <div
      class="radioStyle"
      :class="{'active': selectedJawab == itemChoice }"
      v-for="(itemChoice, index) in itemsoal.list_answer"
      :key="itemChoice.id_answer"
      @click="setJawaban(itemChoice,itemsoal.id_bank_question)"    >
      <span style="font-weight:bold">{{ abjad[index] }}.  </span> 
      <span v-html="itemChoice.answer"> </span> 
    </div>    
  </div>
</template>

<script>
export default {
  props: ["itemsoal", 'itemjawaban'],
  data() {
    return {
        
      classa: "ant-alert",
      radioStyle: {
        border: "1px solid #ddd",
        borderhover: "1px solid #fff",
      },
      abjad:["A","B","C","D","E","F"],

      selectedJawab: this.itemjawaban,
    };
  },
  methods: {
    setJawaban(selected, idbanksoal) {
      if(this.selectedJawab != selected){
        this.$emit('set-jawaban',selected.id_answer,idbanksoal, 1)
      }
      else
      {
        // this.selectedJawab = {};
        // this.$emit('set-jawaban',"",idbanksoal, 0)
      }
    },
    onSelected() {
    },
  },
  watch:{
    itemjawaban:function(val){
      this.selectedJawab = val;
    }
  }
};
</script>

<style >
.radioStyle {
  display: block;
  line-height: 50px;
  border: 1px solid #ddd;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 40px;
  cursor: pointer;
  border-left: 10px solid #ddd;
  background-color: #fff;
}

.radioStyle:hover {
  border: 2px solid #ffe58f;
  border-left: 10px solid #ffe58f;
}

.active {
  background-color: #e7fad3;
  border: 2px solid #92fc42;
  border-left: 10px solid #92fc42;
}
</style>